import React from 'react';
import { Box, Button, Icons, space, breakpoints } from '@generationtux/component-library';
import styled from 'styled-components';
import { useSpring } from 'react-spring';
import { selectItem, scrollTop } from '../../utils/utils';

const StickyBox = styled(Box)`
  position: sticky;
  left: 0;
  right: 0;
  z-index: 100;
  bottom: ${space[4]}px;
  @media (min-width: ${breakpoints['xl']}) {
    bottom: 2vh;
  }
`;

const SaveBox = ({
  setActiveCollection,
  productDetails,
  setProductDetails,
  docBrownsTimeMachine,
  selectedCatalogNumbers,
  activeCollection,
  selected,
  undo,
}) => {
  const { product, isBundle } = productDetails ? productDetails : { product: null, isBundle: null };
  const [, setY] = useSpring(() => ({ y: 0 }));

  return (
    <StickyBox shadowLevel={3} backgroundColor="white" py={1} px={1} my={1} display="flex">
      <Button
        py={[3, 3, 4, 4, 4, 4]}
        px={['24px', '24px', 4, 4, 4, 4]}
        buttonType="default"
        outline
        mr={1}
        onClick={() => {
          scrollTop();
          if (productDetails) {
            setProductDetails(null);
          } else {
            setActiveCollection(null);
          }
        }}
      >
        <Icons.ArrowLeft />
      </Button>
      <Button
        py={[3, 3, 4, 4, 4, 4]}
        buttonType={productDetails ? 'info' : selected ? 'info' : 'default'}
        mr={1}
        style={{ flexGrow: 1 }}
        onClick={() => {
          scrollTop();
          productDetails &&
            docBrownsTimeMachine(selectItem(selectedCatalogNumbers, activeCollection, product, isBundle), true, null);
          setActiveCollection(null);
        }}
      >
        <Icons.Check />
      </Button>
      <Button
        py={[3, 3, 4, 4, 4, 4]}
        px={['24px', '24px', 4, 4, 4, 4]}
        buttonType="default"
        outline
        onClick={() => {
          setY({
            y: 0,
            reset: true,
            from: { y: window.scrollY },
            onFrame: props => window.scroll(0, props.y),
          });
        }}
      >
        <Icons.TriangleUp />
      </Button>
    </StickyBox>
  );
};

export default SaveBox;
